import { Palette } from '@mui/material';
import {
  SPACE_CARD_BG,
  SPACE_CARD_SHADOW,
  SPACE_WIDGET_CONTAINER_BG_DARK,
  SPACE_WIDGET_CONTAINER_BG_LIGHT,
  SPACE_WIDGET_CONTAINER_BORDER_DARK,
  SPACE_WIDGET_CONTAINER_BORDER_LIGHT,
  SPACE_WIDGET_EMPTY_STATE_BG_DARK,
  SPACE_WIDGET_EMPTY_STATE_BG_LIGHT,
  SPACE_WIDGET_ERROR_MESSAGE_COLOR,
  SPACE_WIDGET_ERROR_RETRY_BG,
  SPACE_WIDGET_ERROR_RETRY_TEXT,
} from './spaceWidgetConstants';

export const getSpaceWidgetColors = (palette: Palette) => {
  const isDark = palette.mode === 'dark';

  return {
    cardBg: SPACE_CARD_BG,
    cardShadow: SPACE_CARD_SHADOW,
    containerBg: isDark
      ? SPACE_WIDGET_CONTAINER_BG_DARK
      : SPACE_WIDGET_CONTAINER_BG_LIGHT,
    containerBorder: isDark
      ? SPACE_WIDGET_CONTAINER_BORDER_DARK
      : SPACE_WIDGET_CONTAINER_BORDER_LIGHT,
    cardText: 'rgba(255, 255, 255, 1)',
    metaText: 'rgba(255, 255, 255, 0.7)',
    chipBg: '#FFFFFF29',
    chipText: 'rgba(255, 255, 255, 1)',
    progressFill: 'rgba(129, 199, 132, 1)',
    progressLabel: 'rgba(232, 245, 233, 1)',
    progressTrack: 'rgba(0, 0, 0, 0.14)',
    thumbnailBg: 'rgba(255, 255, 255, 0.12)',
    iconGlyph: 'rgba(255, 255, 255, 0.56)',
    resumeButtonBorder: 'rgba(255, 255, 255, 0.5)',
    resumeButtonHoverBg: 'rgba(255, 255, 255, 0.08)',
    /** Solid arrow color — active uses full opacity, disabled uses 0.3 (ScrollBox). */
    navArrowIcon: palette.text.primary,
    emptyStateBg: isDark
      ? SPACE_WIDGET_EMPTY_STATE_BG_DARK
      : SPACE_WIDGET_EMPTY_STATE_BG_LIGHT,
    emptyStateTitle: palette.text.primary,
    emptyStateSubtitle: palette.text.secondary,
    errorMessage: SPACE_WIDGET_ERROR_MESSAGE_COLOR,
    errorIcon: SPACE_WIDGET_ERROR_MESSAGE_COLOR,
    errorRetryBg: SPACE_WIDGET_ERROR_RETRY_BG,
    errorRetryText: SPACE_WIDGET_ERROR_RETRY_TEXT,
    errorRetryHoverBg: 'rgba(196, 176, 242, 1)',
  } as const;
};
